import AIPromptModal from '@/component/common/modal/AIPrompt/AIPromptModal';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { IconButton, TextField } from '@material-ui/core';
import { useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { multiPanelAtom } from '@/state/atom/panelAtom';
import { updateTabNameAfterSendMessage } from '../handler/ChatAIHandler';
import { sendAIChatMessage } from '@/service/chatAIService';
import { userAtom } from '@/state/atom/userAtom';
import { buildDrillDownSearchParam } from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';
import Constant from '@/common/constant/Constant';
import moment from 'moment';
import { I18n } from 'aws-amplify';
import Utils from '@/common/utils/utils';
import { createKibanaInteractChatAI } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import { v4 as uuidv4 } from 'uuid';

import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { handleToggleUsingBasicPrompt, openPromptTicketPanel } from '../handler/ChatAIHandler';
import { setPanelSelector } from '@/state/selector/panelSelector';

import { getDrilldownItemDataSelected } from "@/component/ticketList/handler/KnowledgeTicketHandler"
import ConfirmDialog from '@/common/dialog/ConfirmDialog';

export default function InputChatAI({
    setListMessageContent,
    panelId,
    tabId,
    API,
    projectInfo,
    setTriggerReload,
    filterKnowledgeListData,
    basicPrompt,
    isEnableBtnSend,
    setIsEnableBtnSend,
    listMessageContent,
    resetSearchCondition,
    corporationSelected,
    tabNameChatAI,
    titleTicket,
    setUserSelectedPrompt,
    userSelectedPrompt,
    promptInternalTicket,
    promptExternalTicket,
    setIsOpenModalReloadPage,
    isLoading,
    setIsLoading,
    usingBasicPrompt,
    idOfResponseMessage,
    setIdOfResponseMessage,
    isUsingKnowledgeServiceValue,
    
    toggleUsingKnowledgeTicketList
}) {
    // Fix service on
    isUsingKnowledgeServiceValue = true;
    const [promptOpen, setPromptOpen] = useState(false);
    const [textInput, setTextInput] = useState('');
    const [toggleUsingBasicPrompt, setToggleUsingBasicPrompt] = useState(usingBasicPrompt)

    const corporationDetail = useRecoilValue(corporationAtom);
    const userDetail = useRecoilValue(userAtom);
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    let addNewPanel = useSetRecoilState(setPanelSelector);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    const [isDisabledInputChat, setIsDisabledInputChat] = useState(false);
    const [actionError, setActionError] = useState('');

    const onChangeChatInput = e => {
        setTextInput(e.target.value);
    };

    const onEnterTextInput = async e => {
        if(e.key === 'Enter'&& !e.shiftKey ){
            e.preventDefault();
        }
        if (e.key === 'Enter' && isEnableBtnSend && !e.shiftKey && !Utils.isEmptyString(textInput)) {
            const value = e.target.value;
            try {
                // Sử dụng await để đợi onSendMessage

                onSendMessage(value);
            } catch (error) {
                console.error('Xử lý logic khác:', error);
                let responseMessage = {
                    isFromMe: false,
                    content: I18n.get('MSG-PROCESSING-TIME-EXCEEDED'),
                    isError: true
                };
                updateLastMessage(responseMessage);
                setUserSelectedPrompt([]);
                setIsEnableBtnSend(true);
            }
        }
    };

    const updateLastMessage = newValue => {
        // setListMessageContent(prevArray => {
        //     // Tạo một bản sao của mảng hiện tại
        //     const newArray = [...prevArray];
        //     // Kiểm tra xem mảng có phần tử hay không
        //     if (newArray.length > 0) {
        //         // Cập nhật giá trị cuối cùng của mảng
        //         newArray[newArray.length - 1] = newValue;
        //         // Trả về mảng mới
        //         return newArray;
        //     }
        //     // Trường hợp mảng rỗng, trả về mảng chỉ chứa giá trị mới
        //     return [newValue];
        // });
    };

    const getOptionsSearch = () => {
        let keywordSearch = '';
        // Replace JP space
        if (filterKnowledgeListData.viewStructure?.keyword) {
            keywordSearch = filterKnowledgeListData.viewStructure?.keyword
                ?.toString()
                .replace(/\s+/g, ' ');
        }

        let keywordList = [];
        let methodSearch = Constant.SETTING_SEARCH_KEYWORD.AND;
        if(filterKnowledgeListData.viewStructure?.options?.method === Constant.SETTING_SEARCH_KEYWORD.SIMILAR){
            keywordList = [];
        }else{
             keywordList = keywordSearch ? keywordSearch.split(' ') : [];
             methodSearch = filterKnowledgeListData.viewStructure?.options?.method
                ? filterKnowledgeListData.viewStructure?.options?.method
                : Constant.SETTING_SEARCH_KEYWORD.AND
        }

        let optionSearch = {
            methodSearch: methodSearch,
            attributeSearch: filterKnowledgeListData.viewStructure?.options?.attribute
                ? filterKnowledgeListData.viewStructure?.options?.attribute
                : Constant.SETTING_SEARCH_KEYWORD.MUTIPLE,
            formatSearch: '',
            keywordList: keywordList
        };

        // Search by date / time
        let fromSearchDate;
        let toSearchDate;

        let agoUnit = '';
        if (
            filterKnowledgeListData.viewStructure.options?.searchDateType ===
            Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.AGO
        ) {
            agoUnit = filterKnowledgeListData.viewStructure.options?.searchDateAgoUnit
                ? filterKnowledgeListData.viewStructure.options?.searchDateAgoUnit
                : Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.DAY;
            let agoValue = filterKnowledgeListData.viewStructure.options?.searchDateAgoValue
                ? filterKnowledgeListData.viewStructure.options?.searchDateAgoValue
                : 0;
            let agoUnitTime =
                agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.WEEK
                    ? 7 * 24 * 60 * 60 * 1000
                    : 24 * 60 * 60 * 1000;

            // toSearchDate is today
            toSearchDate = moment(new Date()).format('YYYY/MM/DD');

            // 0 days ago
            if (!agoValue && agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.DAY) {
                fromSearchDate = toSearchDate;
            } else if (
                !agoValue &&
                agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.WEEK
            ) {
                // 0 week ago = monday - today
                fromSearchDate = moment()
                    .startOf('isoweek')
                    .format('YYYY/MM/DD');
            } else {
                fromSearchDate = moment(new Date() - agoValue * agoUnitTime).format('YYYY/MM/DD');
            }

            optionSearch.fromSearchDate = fromSearchDate;
            optionSearch.toSearchDate = toSearchDate;
        } else {
            if (filterKnowledgeListData.viewStructure.options?.from) {
                fromSearchDate = filterKnowledgeListData.viewStructure.options.from;
                optionSearch.fromSearchDate = filterKnowledgeListData.viewStructure.options.from;
            }

            if (filterKnowledgeListData.viewStructure.options?.to) {
                toSearchDate = filterKnowledgeListData.viewStructure.options.to;
                optionSearch.toSearchDate = filterKnowledgeListData.viewStructure.options.to;
            }

            if (fromSearchDate && toSearchDate && fromSearchDate > toSearchDate) {
                // switch search date
                let newFromSearchDate = toSearchDate;
                let newToSearchDate = fromSearchDate;

                fromSearchDate = newFromSearchDate;
                toSearchDate = newToSearchDate;

                optionSearch.fromSearchDate = fromSearchDate;
                optionSearch.toSearchDate = toSearchDate;
            }
        }

        if (filterKnowledgeListData?.viewStructure?.options?.otherFields) {
            optionSearch.formatSearch = JSON.stringify(
                filterKnowledgeListData.viewStructure.options.otherFields
            );
        }

        // Sort
        optionSearch.sortType = filterKnowledgeListData?.viewStructure?.options?.hasOwnProperty('sort') && filterKnowledgeListData?.viewStructure?.options['sort']
            ? filterKnowledgeListData.viewStructure?.options['sort']
            : Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT;

        if(filterKnowledgeListData.viewStructure?.options?.getListPdfPage){
            optionSearch.getListPdfPage = filterKnowledgeListData.viewStructure?.options?.getListPdfPage
        }

        if(!Utils.isEmptyString(filterKnowledgeListData.viewStructure?.options?.filePdfId)){
            optionSearch.filePdfId = filterKnowledgeListData.viewStructure?.options?.filePdfId
        }
        // if(filterKnowledgeListData.viewStructure?.options?.isIncludePdfFile){
        //     optionSearch.isIncludePdfFile = filterKnowledgeListData.viewStructure?.options?.isIncludePdfFile
        // };

        optionSearch.isIncludeAttachPdf = 1
        optionSearch.isIncludePdfPage = 1
        optionSearch.isSearchSynonym = 0
        

        // if (filterKnowledgeListData.viewStructure?.options?.isIncludeAttachPdf) {
        //     optionSearch.isIncludeAttachPdf = filterKnowledgeListData.viewStructure?.options?.isIncludeAttachPdf
        // };
        return optionSearch;
    };

    const onSendMessage = async value => {
        let chatPostId = uuidv4()
        let tabName = tabNameChatAI;

        const mock = [
            {
                isFromMe: true,
                user: Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userDetail),
                dateTime: Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(new Date()),
                content: value
            },
            //HIDDEN MESSAGE WARNING WHEN EXCEED MAX TOKEN
            {
                isFromMe: false,
                content: I18n.get('WARNING_EXCEED_MAX_TOKEN'),
                isWaring: true,
                dateTime: Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(new Date()),
                isHidden: true
            },
            {
                isFromMe: false,
                isLoadingMessage: true
            }
        ];
        if(listMessageContent?.length === 0) {
            tabName = value;
            updateTabNameAfterSendMessage(panelList, value, panelId, setPanelList, tabId);
        }

        setListMessageContent(prev => [...prev, ...mock]);
        setIsEnableBtnSend(false);
        setTextInput('');

        let drillDown = buildDrillDownSearchParam(filterKnowledgeListData?.viewStructure);
        let optionSearch = getOptionsSearch();

        let corporationId = corporationDetail.id;
        if(!Utils.isEmptyObject(projectInfo)) {
            corporationId = projectInfo?.affiliationOrganization;
        }
        const drillDownDataForLog = await getDrilldownItemDataSelected(API, filterKnowledgeListData?.viewStructure)
        const dataLog = {
            corporationDetail: corporationDetail,
            projectDetail: projectInuseDetail,
            userDetail: userDetail,
            rootProjectDetail: projectInfo,
            rootCorporationDetailId: corporationSelected,
            tabNameChatAI: `${tabName} ${tabId}`,
            aiChatInquiryText: value,
            basicPromptID: toggleUsingBasicPrompt ? basicPrompt : null,
            basicPromptName: toggleUsingBasicPrompt ? titleTicket : null,
            userSelectedPrompt: userSelectedPrompt,
            projectIdKnowledgeSelected: filterKnowledgeListData?.projectIdKnowledgeSelected,
            keyword: filterKnowledgeListData?.viewStructure?.keyword,
            viewName: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, filterKnowledgeListData?.viewSelected?.name),
            searchTagSuggestKnowledge: Utils.createTagForLogKibana(drillDownDataForLog),
            isTurnOnToggleUsingKnowledgeTicketList: toggleUsingKnowledgeTicketList
        }

        const logKibanaData = createKibanaInteractChatAI(dataLog);
        let listUrlShareLink = Utils.getShareLinkUrls(value)
        console.log('listUrlShareLink',listUrlShareLink)
        const dto = {
            corporationId: corporationId,
            projectId: filterKnowledgeListData?.projectIdKnowledgeSelected,
            currentUserId: userDetail.id,
            chatThreadId: filterKnowledgeListData?.threadId,
            message: value,
            basePrompt: isUsingKnowledgeServiceValue ? basicPrompt : '',
            usingBasicPrompt: isUsingKnowledgeServiceValue ? usingBasicPrompt : false,

            visibilitySettingType: filterKnowledgeListData?.viewStructure?.visibility ? filterKnowledgeListData?.viewStructure?.visibility : Constant.VISIBILITY_SETTING_TYPE.CUSTOMER,
            visibilitySetting: 'new_arrived_knowledge',
            publicRange: '',
            projectInuse: projectInuseDetail.id,
            userAffiliationOrganization: userDetail.affiliationOrganization,
            projectInuseType: projectInuseDetail.type,
            viewId: filterKnowledgeListData?.viewSelectedId,
            optionSearch: optionSearch,
            drillDownSearch: drillDown,
            ticketIdList: [],
            ticketProperty: filterKnowledgeListData?.viewStructure?.ticketProperty,
            resetSearchCondition: isUsingKnowledgeServiceValue ? resetSearchCondition : false,
            from: 0,
            size: 30,
            logKibanaData: JSON.stringify(logKibanaData),
            chatPostId: chatPostId,
            listUrlShareLink: listUrlShareLink,
            currentCorporationId: corporationDetail.id,
            ticketCreatedProjectId: filterKnowledgeListData.ticketCreatedProjectId,
            ticketCreatedCorporationId: filterKnowledgeListData.ticketCreatedCorporationId,
        };
        
        setUserSelectedPrompt([]);
        setIdOfResponseMessage(chatPostId)
        return await sendAIChatMessage(API, dto, setListMessageContent, setIsDisabledInputChat);
    };

    return (
        <div className="chat-input-wrapper">
            {isUsingKnowledgeServiceValue && basicPrompt && (
                <div className="basic-prompt-chip">
                    <OverFlowTooltipWithTabsMui
                        value={I18n.get('LABEL-BASIC-PROMPT')}
                        className={`name-title-tickets`}
                        onClick={()=> openPromptTicketPanel(
                            setIsLoading,
                            userDetail,
                            basicPrompt,
                            projectInuseDetail,
                            setIsOpenModalReloadPage,
                            addNewPanel,
                            setIsOpenAccessDeniedPopup,
                            corporationDetail,
                            setActionError
                        )}
                    />
                    <div className="switch-check">
                        <input
                            type="checkbox"
                            id={`switch-basicPrompt-mode`}
                            checked={toggleUsingBasicPrompt}
                            value={toggleUsingBasicPrompt}
                            onChange={() => 
                                handleToggleUsingBasicPrompt(
                                    panelList,
                                    setPanelList,
                                    panelId,
                                    tabId,
                                    toggleUsingBasicPrompt,
                                    setToggleUsingBasicPrompt
                            )}
                        />
                        <label htmlFor={`switch-basicPrompt-mode`}></label>
                    </div>
                </div>
            )}
            
            <div className="groupForm-chat">
                <div className="group-fild">
                    <div className="formField" data-cy="chat-form-input-field">
                        <TextField
                            multiline
                            name="chatbotName"
                            maxRows={15}
                            className="form-control"
                            variant="outlined"
                            autoComplete="off"
                            placeholder="あなたのメッセージ..."
                            onChange={onChangeChatInput}
                            value={textInput}
                            onKeyPress={async e => await onEnterTextInput(e)}
                            disabled={isDisabledInputChat}
                        />
                    </div>
                    {/* <div className="groupForm-chat--quote mt-2 text-center">{I18n.get('CBOTQUOTE01-2')}</div> */}
                    
                    <div
                        className={`group-fildBtn ${
                            (
                                filterKnowledgeListData?.projectIdKnowledgeSelected === Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG ||
                                isLoading
                            ) &&
                            'hidden' 
                        }`}
                        style={{ maxWidth: '40px' }}
                    >
                        <div className="icon-tools">
                            <IconButton
                                className="itemTools"
                                aria-label="upload picture"
                                component="span"
                                onClick={() => setPromptOpen(!promptOpen)}
                            >
                                <img src="/assets/image/prompt-icon.svg" alt="" />
                            </IconButton>
                        </div>
                    </div>
                </div>
                <div
                    className={`groupBtn-send groupBtn-send-${
                        !Utils.isEmptyString(textInput) && isEnableBtnSend ? 'enable' : 'disabled'
                    }`}
                >
                    <IconButton
                        className="btnSend"
                        onClick={async () => await onSendMessage(textInput)}
                    >
                        <img
                            className={`send-message-icon-${
                                !Utils.isEmptyString(textInput) && isEnableBtnSend
                                    ? 'enable'
                                    : 'disable'
                            }`}
                            src="/assets/image/icon-send.svg"
                            alt=""
                        />
                    </IconButton>
                </div>
            </div>

            {promptOpen && 
                <AIPromptModal
                    isOpen={promptOpen}
                    setIsOpen={setPromptOpen}
                    corporationDetail={corporationDetail}
                    projectInuseDetail={projectInfo}
                    API={API}
                    setTriggerReload={setTriggerReload}
                    setTextInput={setTextInput}
                    projectIdKnowledgeSelected={filterKnowledgeListData?.projectIdKnowledgeSelected}
                    setUserSelectedPrompt={setUserSelectedPrompt}
                    corporationSelected={corporationSelected}
                    promptInternalTicket={promptInternalTicket}
                    promptExternalTicket={promptExternalTicket}
                    setIsOpenModalReloadPage={setIsOpenModalReloadPage}
                    setPromptOpen={setPromptOpen}
                />
            }
            
            <ConfirmDialog
                isOpen={isOpenAccessDeniedPopup}
                msgConfirm={I18n.get('KNOWDEMSG005')}
                okCallBack={() => window.location.reload()}
            />

            <ConfirmDialog 
                isOpen={!Utils.isEmptyString(actionError)} 
                okCallBack={() => {setActionError('')}} 
                msgConfirm={actionError}
                textSubmit={I18n.get('OK')}
            />
        </div>
    );
}
